import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/index.css';
import App from './App';
import "./i18n";
import { CountryProvider } from './context/CountryContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CountryProvider>
      <App />
    </CountryProvider>
  </React.StrictMode>
);